import Title_ru_RU_Class     from "@/core/misc/decorators/Title_ru_RU_Class";

import BaseEntity            from "@/core/misc/BaseEntity";
import Core                  from "@/core/Core";
import DateSimple            from "@/core/types/DateSimple";
import Sum                   from "@/core/types/Sum";
import TehnoShipmentPosition from "@/domains/Shipments/TehnoShipmentPosition";

/**
 * Отгрузка Техно — слепок того, что по отгрузке ушло в Техно.
 * Собирается бэком при выгрузке, руками не правится.
 */
@Title_ru_RU_Class('Отгрузка Техно')
class TehnoShipment extends BaseEntity {
  public shipmentId: number;

  public documentType: string;
  public documentNumber: string;
  public documentDate: DateSimple;
  public shipmentDate: DateSimple;

  /** Реализация, по которой отгрузка ушла в Техно */
  public shipmentToBuyerId: number | null;
  public shipmentToBuyerDate: DateSimple | null;

  public currencyCode: string;
  public sumFull: Sum;

  public accountingCurrencyCode: string;
  /** Как в документе поставщика, без дооценки */
  public accountingSumFull: Sum | null;
  /** Дооценка, растворённая в ценах строк */
  public accountingServiceSumFull: Sum;

  /** Номер фактуры в Техно — после приёмки это уже приходная фактура */
  public externalNumber: string | null;

  public positions: TehnoShipmentPosition[] = [];

  static fromServer(data: any, result = new TehnoShipment()): TehnoShipment {
    super.fromServer(data, result);

    result.documentDate             = Core.utils.hydrate(data.documentDate, DateSimple.fromServer)!;
    result.shipmentDate             = Core.utils.hydrate(data.shipmentDate, DateSimple.fromServer)!;
    result.shipmentToBuyerDate      = Core.utils.hydrate(data.shipmentToBuyerDate, DateSimple.fromServer);
    result.sumFull                  = Core.utils.hydrate(data.sumFull, Sum.fromServer)!;
    result.accountingSumFull        = Core.utils.hydrate(data.accountingSumFull, Sum.fromServer);
    result.accountingServiceSumFull = Core.utils.hydrate(data.accountingServiceSumFull, Sum.fromServer)!;
    result.positions                = Core.utils.hydrateArray(data.positions, TehnoShipmentPosition.fromServer);

    return result;
  }

  /** Сумма документа в Техно: документ поставщика вместе с дооценкой */
  get tehnoSumFull(): Sum | null {
    if (this.accountingSumFull === null) {
      return null;
    }
    else {
      return this.accountingSumFull.plus(this.accountingServiceSumFull);
    }
  }

  /** Удалённые строки хранятся, чтобы удаление дошло до Техно, но в Техно их уже нет */
  get livePositions(): TehnoShipmentPosition[] {
    return this.positions.filter(position => position.isDeleted === false);
  }

  toString(): string {
    return `Отгрузка Техно №${this.id}`;
  }
}

export default TehnoShipment;
